/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTrialPeriodRequestBody
 */
export interface UpdateTrialPeriodRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateTrialPeriodRequestBody
     */
    trialEnd?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrialPeriodRequestBody
     */
    trialDays?: number;
}

/**
 * Check if a given object implements the UpdateTrialPeriodRequestBody interface.
 */
export function instanceOfUpdateTrialPeriodRequestBody(value: object): value is UpdateTrialPeriodRequestBody {
    return true;
}

export function UpdateTrialPeriodRequestBodyFromJSON(json: any): UpdateTrialPeriodRequestBody {
    return UpdateTrialPeriodRequestBodyFromJSONTyped(json, false);
}

export function UpdateTrialPeriodRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTrialPeriodRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'trialEnd': json['trialEnd'] == null ? undefined : json['trialEnd'],
        'trialDays': json['trialDays'] == null ? undefined : json['trialDays'],
    };
}

export function UpdateTrialPeriodRequestBodyToJSON(json: any): UpdateTrialPeriodRequestBody {
    return UpdateTrialPeriodRequestBodyToJSONTyped(json, false);
}

export function UpdateTrialPeriodRequestBodyToJSONTyped(value?: UpdateTrialPeriodRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trialEnd': value['trialEnd'],
        'trialDays': value['trialDays'],
    };
}

